// extracted by mini-css-extract-plugin
module.exports = {"main":"dropdown_main__5F0I_","trigger":"dropdown_trigger__56gVe","dropdownRender":"dropdown_dropdownRender__ehs7P","search":"dropdown_search__C_IUP","li":"dropdown_li__O5_bj"};